"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findChildByType = exports.mergeStyleProp = void 0;
var react_1 = __importDefault(require("react"));
// Use the child prop if it exists, or inherit from the parent prop
var mergeStyleProp = function (parentValue, childValue) {
    return childValue !== undefined ? childValue : parentValue;
};
exports.mergeStyleProp = mergeStyleProp;
var findChildByType = function (children, type) {
    return react_1.default.Children.map(children, function (child) {
        if (child && child.type) {
            var name_1 = child.type.displayName;
            if (name_1 && type.includes(name_1)) {
                return child;
            }
        }
    }) || [];
};
exports.findChildByType = findChildByType;
